import { HistoricalPolls } from './historical-polls';

export class Historical {
    constructor(
        public categoryTitle?: string,
        public historicalPolls?: HistoricalPolls,
    ) { }

    clone() {
        return new Historical(
            this.categoryTitle,
            this.historicalPolls
        );
    }

    get isPollsEmpty() {
        return this.historicalPolls == null;
    }
}
